import React from 'react';
import { connect } from 'redux-scaffolding-ts';
import { useTranslation } from 'react-i18next';
import { ChangeRequestStore, RequestStatus } from '../../../../../../stores/requests/requests-store';
import { IdentityService } from 'services/identity-service';
import { replaceAll } from 'utils/useful-functions';
import { container } from 'inversify.config';
import RequestCancelPopupTw from './request-cancel-popup-tw';

interface RequestCancelButtonTailwindProps {
  requestId: string;
  requestStatus: RequestStatus;
  requestCreatorRoles: string[];
  changeRequestStore?: ChangeRequestStore;
  readOnly: boolean;
  isGea: boolean;
  isGma: boolean;

  onSuccess?: () => void;
  onError?: () => void;
}

const RequestCancelButtonTailwind: React.FC<RequestCancelButtonTailwindProps> = ({
  requestId,
  requestStatus,
  requestCreatorRoles,
  changeRequestStore,
  readOnly,
  isGea,
  isGma,
  onSuccess,
  onError
}) => {
  // static defaultProps = { onSuccess: () => {}, onError: () => {} };

  const [showRequestCancelPopup, setShowRequestCancelPopup] = React.useState(false);
  const { t } = useTranslation();
  const identityService: IdentityService = container.get(IdentityService);
  const currentUserInfo = identityService.getUserInfo();

  const handleOnCancel = () => setShowRequestCancelPopup(false);
  const handleOnClick = () => setShowRequestCancelPopup(true);

  const isVisibleInCurrentStatus = (): boolean => requestStatus.toString() === 'Draft' || requestStatus.toString() === 'Pending';

  const currentUserHasPermission = (): boolean => {
    if (IdentityService.isAdmin(currentUserInfo)) return true;
    if (IdentityService.isReporting(currentUserInfo)) return false;
    if (IdentityService.isPlanner(currentUserInfo) && (isGea || isGma)) return false;

    return (requestCreatorRoles || []).includes(replaceAll(currentUserInfo.activeRole, ' ', ''));
  };

  const isVisible = (): boolean => isVisibleInCurrentStatus() && currentUserHasPermission();

  return (
    isVisible() && (
      <>
        <button
          type="button"
          className={`flex-1 py-2 rounded border 
          ${!readOnly ? 'border-gray-200 text-gray-400' : 'border-gray-400 text-gray-800'}
           font-semibold hover:bg-gray-100 transition-all text-sm`}
          disabled={!readOnly}
          onClick={handleOnClick}
        >
          {t('Cancel Request')}
        </button>
        {showRequestCancelPopup && (
          <RequestCancelPopupTw
            requestId={requestId}
            open={showRequestCancelPopup}
            onCancel={handleOnCancel}
            onSuccess={onSuccess}
            onError={onError}
          />
        )}
      </>
    )
  );
};

export default connect(['changeRequestStore', ChangeRequestStore])(RequestCancelButtonTailwind);
